import React from "react";
import {BreadCrumbItem} from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import TableSection from "./TableSection";
import {useListarProductos} from "../../../services/productosServicios";
import LoadingScreen from "../../organisms/LoadingScreen";

const breadCrumbs: BreadCrumbItem[] = [
    {
        path: "/",
        label: "Inicio"
    },
    {
        path: "/productos",
        label: "Productos",
        isActive: true
    }
]

function ListaProductos() {
    const {data, isLoading, isSuccess} = useListarProductos();

    return (
        <Page description="Visualiza, edita y crea productos." title="Productos" breadCrumbs={breadCrumbs}>
            <LoadingScreen isLoading={isLoading}/>
            {
                data && isSuccess &&
                <TableSection items={data}/>
            }
        </Page>
    );
}

export default ListaProductos;